import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { bemBlock } from '../../modules/bem';
import { ScrollArea } from '../scroll-area/ScrollArea';

import { ActionsMenuSeparator as Separator } from './ActionsMenuSeparator';

import './ActionsMenuSubContent.less';

const block = bemBlock('n-actions-menu-sub-content');

type SubContentOwnProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  scrollArea?: React.ComponentType<{ children: React.ReactNode }>;
};

type SubContentProps = React.ComponentPropsWithoutRef<typeof DropdownMenu.SubContent> &
  SubContentOwnProps;

function DefaultScrollArea({ children }: { children: React.ReactNode }) {
  return (
    <ScrollArea className={block('scroll-area')}>
      <ScrollArea.Viewport className={block('scroll-area-viewport')}>
        {children}
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar orientation="vertical" />
      <ScrollArea.Scrollbar orientation="horizontal" />
      <ScrollArea.Corner />
    </ScrollArea>
  );
}

export const ActionsMenuSubContent = React.forwardRef<
  React.ElementRef<typeof DropdownMenu.SubContent>,
  SubContentProps
>(function ActionsMenuSubContent(
  {
    className,
    children,
    header,
    footer,
    scrollArea: ScrollAreaWrapper = DefaultScrollArea,
    ...props
  },
  ref,
) {
  return (
    <DropdownMenu.SubContent
      ref={ref}
      className={block({
        extra: className,
      })}
      {...props}
    >
      {header && (
        <>
          <div className={block('header')}>{header}</div>
          <Separator />
        </>
      )}
      <ScrollAreaWrapper>{children}</ScrollAreaWrapper>
      {footer && (
        <>
          <Separator />
          {footer}
        </>
      )}
    </DropdownMenu.SubContent>
  );
});
